import { render, staticRenderFns } from "./FrontierRegistration.vue?vue&type=template&id=ff9433a2&scoped=true"
import script from "./FrontierRegistration.vue?vue&type=script&lang=js"
export * from "./FrontierRegistration.vue?vue&type=script&lang=js"
import style0 from "./FrontierRegistration.vue?vue&type=style&index=0&id=ff9433a2&prod&scoped=true&lang=css"
import style1 from "./FrontierRegistration.vue?vue&type=style&index=1&id=ff9433a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9433a2",
  null
  
)

export default component.exports